import { api } from '@/lib/api';
import type { Part } from './types';
import type { PartCreateValues, PartUpdateValues } from './schema';

/**
 * Parts REST client over the shared axios instance.
 *
 * Endpoints (Phase 4b):
 *   GET    /parts                  list (optionally filter by partTypeId)
 *   GET    /parts/:id              detail
 *   POST   /parts                  create
 *   PATCH  /parts/:id              update (name/copy/flags only)
 *   DELETE /parts/:id              soft-delete
 */
export const partsApi = {
  list: async (params?: { partTypeId?: string }): Promise<Part[]> => {
    const { data } = await api.get<Part[]>('/parts', { params });
    return data;
  },

  getById: async (id: string): Promise<Part> => {
    const { data } = await api.get<Part>(`/parts/${id}`);
    return data;
  },

  create: async (input: PartCreateValues): Promise<Part> => {
    const { data } = await api.post<Part>('/parts', input);
    return data;
  },

  update: async (id: string, patch: PartUpdateValues): Promise<Part> => {
    const { data } = await api.patch<Part>(`/parts/${id}`, patch);
    return data;
  },

  remove: async (id: string): Promise<void> => {
    await api.delete(`/parts/${id}`);
  },
};
